import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-indigo-500"></div>
  </div>
);

const ErrorDisplay = ({ error }) => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="bg-red-100 border border-red-400 text-red-700 px-6 py-4 rounded">
      {error}
    </div>
  </div>
);

const ProtectedRoute = ({ children, requireAdmin }) => {
  const { user, loading, error } = useAuth();
  const location = useLocation();

  // Handle loading state
  if (loading) {
    return <LoadingSpinner />;
  }

  // Handle authentication errors
  if (error) {
    return <ErrorDisplay error={error} />;
  }

  // Handle unauthenticated users
  if (!user) {
    // Save full URL for redirect after login, but never save login or register paths
    const currentPath = window.location.pathname + window.location.search + window.location.hash;
    
    // Only save non-auth paths
    if (!currentPath.startsWith('/login') && !currentPath.startsWith('/register')) {
      localStorage.setItem('redirectPath', currentPath);
      
      // Also save in location state as backup
      return <Navigate to="/login" state={{ from: { pathname: currentPath } }} replace />;
    } else {
      // Don't save auth paths as redirect destinations
      return <Navigate to="/login" replace />;
    }
  }

  // Handle admin route access
  if (requireAdmin) {
    if (user.role !== 'admin') {
      return <Navigate to="/inventory" replace />;
    }
  }

  // Render protected content
  return <>{children}</>;
};

export default ProtectedRoute;
